











import Vue, { PropType } from 'vue';
import favorite, {
  SnapShotByBrand,
  SnapShotByItem,
} from '@/modules/buyer/favorite';

export default Vue.extend({
  name: 'GCheckButtonIcon',
  props: {
    brandId: {
      type: [String, null] as PropType<string | null>,
      default: null,
    },
    itemId: {
      type: [String, null] as PropType<string | null>,
      default: null,
    },
  },
  data() {
    return {
      checked: false,
      snapShotByBrand: new SnapShotByBrand(),
      snapShotByItem: new SnapShotByItem(),
    };
  },
  async mounted() {
    const uid = this.$auth.uid;
    if (!this.brandId) throw new Error('can not find brandId');
    if (!this.itemId) {
      this.snapShotByBrand.snapshot(
        uid,
        this.brandId,
        (checked: boolean) => {
          this.checked = checked;
        },
        (error: Error) => {
          throw error;
        },
      );
    } else {
      this.snapShotByItem.snapshot(
        uid,
        this.brandId,
        this.itemId,
        (checked: boolean) => {
          this.checked = checked;
        },
        (error: Error) => {
          throw error;
        },
      );
    }
  },
  destroyed() {
    this.snapShotByBrand.detach();
    this.snapShotByItem.detach();
  },
  methods: {
    gtmPageContext() {
      return {
        // NOTE: plugins/gtm.ts の PageView と同じキーで「どのページか」を載せる
        'content-name': `/web${this.$route?.fullPath || ''}`,
        'content-view-name': (typeof document !== 'undefined' && document.title) || '',
        routeName: this.$route?.name || '',
      };
    },
    async onClickCheck() {
      const uid = this.$auth.uid;

      if (!this.brandId) throw new Error('Must be set brandId');
      if (!uid) throw new Error('can not find uid');
      if (!this.itemId) {
        this.$gtm.trackEvent({
          ...this.gtmPageContext(),
          event: 'check_brand',
          brand_id: this.brandId,
          checked: !this.checked,
        });
        await favorite.checkBrand(uid, this.brandId, !this.checked);
      } else {
        this.$gtm.trackEvent({
          ...this.gtmPageContext(),
          event: 'check_item',
          brand_id: this.brandId,
          item_id: this.itemId,
          checked: !this.checked,
        });
        await favorite.checkItem(uid, this.brandId, this.itemId, !this.checked);
      }
    },
  },
});
